import React from 'react';
import { useSelector } from 'react-redux';
import { getIsImporting, getSelectedUsers } from 'selectors/userPermissionsPage';
import ImportUserSidebar from './ImportUserSidebar';
import MultipleUserSidebar from './MultipleUserSidebar';
import SingleUserSidebar from './SingleUserSidebar';

type ComponentProps = {
  footer?: boolean;
  saveInApply?: boolean;
  shouldDeleteUser?: boolean;
  isMainUsersPage: boolean;
  renderExtraOptions?: boolean;
};

const UserSidebar: React.FC<ComponentProps> = ({
  footer = true,
  saveInApply = false,
  shouldDeleteUser = false,
  isMainUsersPage,
  renderExtraOptions = true,
}) => {
  const selectedUsers = useSelector(getSelectedUsers);
  const isImporting = useSelector(getIsImporting);

  if (isImporting) {
    return <ImportUserSidebar footer={footer} renderExtraOptions={renderExtraOptions} />;
  }

  if (selectedUsers.length === 1) {
    return (
      <SingleUserSidebar
        footer={footer}
        saveInApply={saveInApply}
        shouldDeleteUser={shouldDeleteUser}
        isMainUsersPage={isMainUsersPage}
        renderExtraOptions={renderExtraOptions}
      />
    );
  }

  return (
    <MultipleUserSidebar
      footer={footer}
      saveInApply={saveInApply}
      shouldDeleteUser={shouldDeleteUser}
      isMainUsersPage={isMainUsersPage}
      renderExtraOptions={renderExtraOptions}
    />
  );
};
export default UserSidebar;
